import branches from "./branches";
import orders from "./orders";
import providers from "./providers";
import cities from "./cities";
import vehicles from "./vehicles";

export default {
    modules: {
        branches,
        orders,
        providers,
        cities,
        vehicles
    },
    namespaced: true
}
